import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import Seo from '../common/Seo';

const NotFoundPage = () => {
	const location = useLocation();

	return (
		<>
			<Seo
				title="Page Not Found - BrokenCosmos Labs"
				description="The page you requested could not be found."
				path={location.pathname || '/404'}
				noIndex
			/>
			<Box sx={{ py: { xs: 10, md: 14 }, textAlign: 'center' }}>
				<Container maxWidth="md">
					<Typography variant="h1" component="h1" sx={{ fontSize: 'clamp(2rem, 5vw, 3rem)', mb: 1.5 }}>
						Page not found
					</Typography>
					<Typography variant="body1" sx={{ mb: 3 }}>
						The page you are looking for does not exist or has moved.
					</Typography>
					<Button component={Link} to="/" variant="contained">
						Back to homepage
					</Button>
				</Container>
			</Box>
		</>
	);
};

export default NotFoundPage;
